"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSaga = runSaga;
exports.asyncTakeFirst = exports.takeFirst = exports.takeOnce = exports.createTaker = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _effects = require("redux-saga/effects");

var _ramda = require("ramda");

var createTaker = function createTaker(storedBy) {
  var removeOnSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var takedParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee3(pattern, saga) {
      var _len,
          args,
          _key,
          task,
          _args3 = arguments;

      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              for (_len = _args3.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = _args3[_key];
              }

              _context3.next = 3;
              return (0, _effects.fork)(
              /*#__PURE__*/
              _regenerator["default"].mark(function _callee2() {
                return _regenerator["default"].wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return (0, _effects.takeEvery)(pattern,
                        /*#__PURE__*/
                        _regenerator["default"].mark(function _callee(action) {
                          var params, result;
                          return _regenerator["default"].wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  params = storedBy(action);

                                  if ((0, _ramda.contains)(params, takedParams)) {
                                    _context.next = 13;
                                    break;
                                  }

                                  takedParams.push(params);
                                  _context.prev = 3;
                                  _context.next = 6;
                                  return _effects.call.apply(void 0, [saga].concat((0, _toConsumableArray2["default"])(args.concat(action))));

                                case 6:
                                  result = _context.sent;

                                  if (removeOnSuccess || (0, _ramda.prop)('error', result)) {
                                    takedParams.splice(takedParams.indexOf(params), 1);
                                  }

                                  _context.next = 13;
                                  break;

                                case 10:
                                  _context.prev = 10;
                                  _context.t0 = _context["catch"](3);
                                  takedParams.splice(takedParams.indexOf(params), 1);

                                case 13:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee, null, [[3, 10]]);
                        }));

                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

            case 3:
              task = _context3.sent;
              return _context3.abrupt("return", task);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })
  );
};

exports.createTaker = createTaker;
var takeOnce = createTaker((0, _ramda.prop)('params'), false);
exports.takeOnce = takeOnce;
var takeFirst = createTaker((0, _ramda.prop)('type'));
exports.takeFirst = takeFirst;
var asyncTakeFirst = createTaker((0, _ramda.prop)('params'));
exports.asyncTakeFirst = asyncTakeFirst;

function runSaga(middleware, saga) {
  if (!middleware) {
    throw new Error('Before running a Saga, you must set the Saga middleware in <SagaProvider />');
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return middleware.run.apply(middleware, [saga].concat(args));
}